import React, { Component } from 'react';

export class Contact extends Component {
  static displayName = Contact.name;

  render () {
    return (
      <div>
        <section className="hero-contact container">
        <div className="text">
          <h1>Mahakaleshwar Aashram</h1>
          <p>
            Guru Shri Brahmanand Saraswati Ji Maharaj
          </p>
        </div>

        <div className="image">
          <div className="aura"></div>
          <img
            src="/images/contact-hero.jpg"
            alt="Mahakaleshwar Aashram"
          />
        </div>
      </section>

      <section className="contact-section container">
        <div className="info-grid">
          {/* Card 1 */}
          <div className="card">
            <h3>📍 Mahakaleshwar Aashram</h3>
            <p>
              <strong>Mahakaleshwar Aashram</strong>
              <br />
              Maa Bala Sundri Mandri, Deoband, Saharanpur, Uttar Pradesh— 247554
              <br />
              📞 +91 90128-60364
              <br />
              ✉️ info@swami-brahmanand-saraswati.com
            </p>

            <div className="map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000.196561374002!2d77.68675254863851!3d29.682501328808623!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ea425a8e2fe95%3A0x671e37ff86311e00!2sSri%20Tripur%20Maa%20Bala%20Sundari%20Mandir!5e0!3m2!1sen!2sin!4v1766652253362!5m2!1sen!2sin"
                title="Mahakaleshwar Aashram, Maa Bala Sundri Mandir, Deoband, Saharanpur, Uttar Pradesh"
              ></iframe>
            </div>
          </div>

          {/* Card 2 */}
          {/*<div className="card">
            <h3>📍 Varanasi Branch</h3>
            <p>
              <strong>Sanatan Dharm Seva Kendra</strong>
              <br />
              Dashashwamedh Ghat Road, Varanasi, Uttar Pradesh — 221001
              <br />
              📞 +91 99887 77665
              <br />
              ✉️ varanasi@sanatantrust.org
            </p>

            <div className="map">
              <iframe
                src="https://www.google.com/maps?q=Dashashwamedh+Ghat,+Varanasi&output=embed"
                title="Varanasi Map"
              ></iframe>
            </div>
          </div>*/}

        </div>
      </section>

      <section className="social-section container">
        <h2>Follow Us</h2>

        <div className="social-links">
          <a href="https://www.facebook.com/profile.php?id=61585870640010" target="_blank">
            <img src="https://img.icons8.com/color/1200/facebook-new.jpg" alt="Facebook" />
          </a>
          <a href="#">
            <img src="https://img.icons8.com/color/1200/instagram-new.jpg" alt="Instagram" />
          </a>
          <a href="https://www.youtube.com/@BrahmanandSaraswatiMaharaj" target="_blank">
            <img src="https://img.icons8.com/color/1200/youtube-play.jpg" alt="YouTube" />
          </a>
          <a href="#">
            <img src="https://img.icons8.com/color/1200/twitterx--v1.jpg" alt="Twitter" />
          </a>
        </div>
      </section>

      </div>
    );
  }
}